export default () => {
  const modal = document.querySelector(".modal");
  if (modal) {
    const body = document.body;
    const closeModalButtons = modal.querySelectorAll(".close");
    const openModal = () => {
      modal.classList.add("visible");
      body.classList.add("overflow-hidden");
      if (modal.hasAttribute("data-blur")) {
        body.classList.add("is-modal-blur");
      }
    };

    const closeModal = () => {
      modal.classList.remove("visible");
      body.classList.remove("overflow-hidden");
      if (modal.hasAttribute("data-blur")) {
        body.classList.remove("is-modal-blur");
      }
    };

    closeModalButtons.forEach((closeBtn) => {
      closeBtn.addEventListener("click", closeModal);
    });

    openModal();
  }
};
